import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";

import LogoAbba from "../../images/DavideAbbadessaFullStackWebDeveloper.png"

const linkDavideAbbadessaFullStackWebDeveloper = process.env.REACT_APP_LINKDAVIDEABBADESSAFULLSTACKDEVELOPER;
const numeroDiTelefono = process.env.REACT_APP_WHATSAPP_NUMERO;
const emailContatto = process.env.REACT_APP_EMAILCONTATTO;
const indirizzo = process.env.REACT_APP_INDIRIZZO;
const googleMapsLink = process.env.REACT_APP_GOOGLEMAPSINDIRIZZO;
const googleReviewLink = process.env.REACT_APP_LINKREVIEWGOOGLE;



export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const info = [
  {
    title: "🗺 INDIRIZZO",
    desc: indirizzo,
    link: googleMapsLink,
  },
  {
    title: "💌 EMAIL",
    desc: emailContatto,
    link: `mailto:${emailContatto}`,
  },
  {
    title: "☎ TELEFONO",
    desc: numeroDiTelefono,
    link: `tel:${numeroDiTelefono}`,
  },
];

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "1",
    title: "Info & Support",
    menus: [
      { href: "/contact", label: "Contattaci" },
      { href: "/chi-siamo", label: "Chi Siamo" },
      { href: "https://www.google.com/search?sca_esv=293021c43ebdc58d&rlz=1C1UEAD_enIT1092IT1092&sxsrf=ADLYWIIEOaA4ypMKjvvrx7RKM9lEobknTQ:1733313710666&q=villa+greco+tindari&si=ACC90nwjPmqJHrCEt6ewASzksVFQDX8zco_7MgBaIawvaF4-7iqANmBtdSqdVUGe1Dh-U_k7lL5XfWPMTNLYmym0_ZRkoTqRYeg7xIRUjHW4baG2ub0zgKg%3D&uds=ADvngMgcma2krFDWAfXM9WWaYuEsG6AecR1McBoOVfDSfbvlOHG88SeiWbdZu_xO7LReTCB2bKsQ7j9T927Qhd8gA0-bccXQZgGYk03gcg3vZ4RMJxBcC6E&sa=X&ved=2ahUKEwjyqIjgiI6KAxWw_gIHHarDCxMQ3PALegQIHRAE&biw=1920&bih=911&dpr=1", label: "Recensioni Google" },
      { href: "https://www.booking.com/reviews/it/hotel/ulivo-in-villa-greco.it.html", label: "Recensioni Booking" },
      { href: "https://it.airbnb.ch/rooms/796319225989264796/reviews?source_impression_id=p3_1733326386_P3WZfdOx6u7OwlVC", label: "Recensioni AirBnB" },
    ],
  },
  {
    id: "2",
    title: "Policy",
    menus: [
      { href: "/privacy-policy", label: "Privacy Policy" },
      { href: "/termini-condizioni", label: "Termini e Condizioni d'Uso" },
      { href: "/cookie-policy", label: "Cookie Policy" },
    ],
  },
  

  // {
  //   id: "3",
  //   title: "Resources",
  //   menus: [
  //     { href: "#", label: "Best practices" },
  //     { href: "#", label: "Support" },
  //     { href: "#", label: "Developers" },
  //     { href: "#", label: "Learn design" },
  //     { href: "#", label: "Releases" },
  //   ],
  // },
  // {
  //   id: "5",
  //   title: "Community",
  //   menus: [
  //     { href: "#", label: "Discussion Forums" },
  //     { href: "#", label: "Code of Conduct" },
  //     { href: "#", label: "Community Resources" },
  //     { href: "#", label: "Contributing" },
  //     { href: "#", label: "Concurrent Mode" },
  //   ],
  // },
  // {
  //   id: "6",
  //   title: "Getting started",
  //   menus: [
  //     { href: "#", label: "Installation" },
  //     { href: "#", label: "Release Notes" },
  //     { href: "#", label: "Upgrade Guide" },
  //     { href: "#", label: "Browser Support" },
  //     { href: "#", label: "Editor Support" },
  //   ],
  // },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <a
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-24 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 mb-5">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
          <div className="col-span-2 flex items-center md:col-span-3">
            <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
          </div>
        </div>
        
        {widgetMenus.map(renderWidgetMenuItem)}
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
          {info.map((item, index) => (
                <div key={index}>
                  <h3 className="uppercase font-semibold text-sm dark:text-neutral-200 tracking-wider">
                    {item.title}
                  </h3>
                  <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
                    {item.link ? (
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        {item.desc}
                      </a>
                    ) : (
                      item.desc
                    )}
                  </span>
                </div>
              ))}
          </div>
        </div>
        <div className="col-span-2 md:col-span-1 text-center mt-5">
    <a href={linkDavideAbbadessaFullStackWebDeveloper} target="_blank" rel="noopener noreferrer">
        <img 
            src={LogoAbba} 
            alt="Logo Davide Abbadessa Full Stack Developer" 
            style={{ width: '400px', height: 'auto' }} 
        />
    </a>
</div>
      </div>
        <div className="col-span-2 md:col-span-1 text-center mt-5">
          <p className="mt-2 text-neutral-500 dark:text-neutral-400"> &copy; {new Date().getFullYear()} Produced by Davide Abbadessa, Tutti i diritti riservati.</p>
          <p className="mt-2 text-neutral-500 dark:text-neutral-400"> &copy; {new Date().getFullYear()} Villa Greco, Tutti i diritti riservati.</p>
        </div>
    </div>
  );
};

export default Footer;
